import { render, staticRenderFns } from "./MovementUpdate.vue?vue&type=template&id=5a998bdc&scoped=true&"
import script from "./MovementUpdate.vue?vue&type=script&lang=js&"
export * from "./MovementUpdate.vue?vue&type=script&lang=js&"
import style0 from "./MovementUpdate.vue?vue&type=style&index=0&id=5a998bdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a998bdc",
  null
  
)

export default component.exports